import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { updateRisk } from "../../../../../actions/Utilities/Risk";
import { toast } from "../../../../../components/toastNotification";
import { RiskDataType } from "../types/RiskInterface";

export default function useUpdateRisk() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((risk: RiskDataType) => updateRisk(risk), {
    onSuccess: (res) => {
      if (res === "Duplicate") {
        toast.fire("Saving Failed", "The data already exists!", "error");
      } else {
        queryClient.invalidateQueries(["GetRisk"]);
        toast.fire("Success", "Risk Updated Successfully", "success");
      }
    },
    onError: (error: any) => {
      if (
        error.response.data.message === "Failed sending of email" ||
        error.response.data.message === "Failed inserting of notification"
      ) {
        toast.fire(
          "Success",
          "Risk updated successfully, but " + error.response.data.message,
          "warning"
        );
        queryClient.invalidateQueries("GetRisk");
      } else {
        toast.fire(
          "Update Risk failed",
          "Server Error: Cannot Update Risk",
          "error"
        );
      }
    },
  });
  return mutate;
}
